function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d06716",
  fillRule: "nonzero",
  d: "M16.94 26.47v-1.2c1.77-.3 1.92-.71 1.44-2.22-.3-1.02-.75-2.46-1.21-3.86h-5.78c-.33 1.06-.72 2.29-1.08 3.65-.42 1.64-.36 2.12 1.84 2.42v1.2H5.41l.03-1.2c1.99-.27 2.35-.64 3.34-3.51L14.95 4.2l1.53-.44c1.93 5.97 3.79 11.91 5.75 17.79 1.02 3 1.42 3.45 3.31 3.72v1.2h-8.6zm-2.56-16.46h-.09c-.84 2.49-1.6 4.95-2.38 7.37h4.69l-2.22-7.37z"
});

var SvgAce = function SvgAce(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAce, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ace.f121eb5e.svg";
export { ForwardRef as ReactComponent };